module.exports = __webpack_public_path__ + "static/media/pdf.ef78dd67.svg";